<template>
    <v-app id="app">
        <nav-bar />
        <v-main>
            <v-container class="bg mx-0 px-0 mb-15" :class="$vuetify.breakpoint.mobile ? 'mb-15 mt-0' : 'my-0 py-0'" fluid :style="`{background: url(${getBackground}) !important; }`">
                <section-title v-if="$vuetify.breakpoint.mobile" :title="$route.meta" :class="$vuetify.breakpoint.mobile && $route.name !== 'Team' && $route.name !== 'Match' && $route.name !== 'FacebookPostMatch' ? 'mb-16' : ''" />
                <v-row
                    no-gutters
                    class="py-0 my-0"
                >
                    <v-col
                        cols="12"
                        class="py-0 my-0 app-content-shell"
                    >
                        <router-view />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <custom-footer v-if="!$vuetify.breakpoint.mobile" />
        <v-btn
            v-show="fab"
            v-scroll="onScroll"
            fab
            dark
            fixed
            :bottom="!$vuetify.breakpoint.mobile"
            :style="$vuetify.breakpoint.mobile ? 'bottom: 80px; right: 5px;' : 'bottom: 100px; right: 25px;'"
            :right="!$vuetify.breakpoint.mobile"
            :small="$vuetify.breakpoint.mobile"
            color="#dddddf"
            class="custom-orange"
            style="z-index: 14;"
            @click="toTop"
        >
            <v-icon :large="!$vuetify.breakpoint.mobile" color="white">mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import NavBar from '@/components/NavBar.vue'
    import CustomFooter from '@/components/Footer.vue'
    import SectionTitle from '@/components/Title'
    export default {
        name: 'App',
        components: {
            NavBar,
            SectionTitle,
            CustomFooter
        },
        data() {
            return {
                backgrounds: ['@/assets/background.jpg', '@/assets/background.jpg', '@/assets/background.jpg'],
                fab: false
            }
        },
        watch: {
            $route() {
                document.title = `${this.$route.meta}`
            }
        },
        created() {
        },
        methods: {
            getBackground() {
                return require(this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)])
            },
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            }
        }
    }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Arial&display=swap');
@import url('https://fonts.googleapis.com/css?family=Ubuntu&display=swap');

* {
    text-transform: capitalize;
}

#app .article-body-content,
#app .article-body-content * {
    text-transform: none !important;
}

.v-slide-group__prev {
    display: none !important;
}

.v-tab--active {
    background: linear-gradient(90deg, #ad373d 0%, #ae2930 50%, #232d44 70%, #223152 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.custom-orange {
    background: linear-gradient(90deg, #ad373d 0%, #ae2930 50%, #232d44 70%, #223152 100%);
}

.custom-orange-text {
    background-image: linear-gradient(90deg, #ad373d 0%, #ae2930 50%, #232d44 70%, #223152 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

#app {
    font-family: Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
}

.page-shell {
    padding-left: clamp(10px, 2vw, 24px) !important;
    padding-right: clamp(10px, 2vw, 24px) !important;
    padding-bottom: clamp(16px, 3vw, 32px) !important;
}

.app-content-shell {
    padding-left: clamp(10px, 2vw, 24px) !important;
    padding-right: clamp(10px, 2vw, 24px) !important;
    padding-bottom: clamp(16px, 3vw, 32px) !important;
}

@media only screen and (max-width: 600px) {
    .page-shell {
        padding-left: 8px !important;
        padding-right: 8px !important;
        padding-bottom: 16px !important;
    }

    .app-content-shell {
        padding-left: 8px !important;
        padding-right: 8px !important;
        padding-bottom: 16px !important;
    }
}

.bg {
    /* position: absolute; */
    background: #69b0e5;
    background-size: cover;
    background-repeat: no-repeat;

    /* background: rgb(255,162,0);
    background: linear-gradient(90deg, rgba(255,162,0,1) 0%, rgba(240,240,242,1) 50%); */
    width: 100%;
    height: auto;
    min-height: 100%;
}

@media only screen and (max-width: 1000px) {
    .bg {
        background: #69b0e5;
    }
}

.v-data-table {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-weight: 400;
}

thead {
    white-space: nowrap;
}

.secondary-font {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-weight: 700;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:horizontal {
    border-radius: 10px;
}

.clickable {
    cursor: pointer !important;
}

table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
    position: sticky !important;
    left: 0;
    background: white;
}

</style>
